import { createFileRoute } from '@tanstack/react-router'
import type { ConnectRequest } from '@/features/mcp-connect/api'
import { ConnectPage } from '@/features/mcp-connect/connect-page'

/**
 * Route shell for the Support MCP's consent step (ADR-0040). The API's
 * /api/platform/oauth/authorize sends the browser here; the `_authenticated`
 * guard signs the admin in first and returns here with the same query.
 */
export const Route = createFileRoute('/_authenticated/connect')({
  validateSearch: (search: Record<string, unknown>): ConnectRequest => ({
    client_id: typeof search.client_id === 'string' ? search.client_id : '',
    redirect_uri: typeof search.redirect_uri === 'string' ? search.redirect_uri : '',
    code_challenge: typeof search.code_challenge === 'string' ? search.code_challenge : '',
    state: typeof search.state === 'string' ? search.state : undefined,
  }),
  component: function ConnectRoute() {
    return <ConnectPage request={Route.useSearch()} />
  },
})
